export const APP_NAME = process.env.REACT_APP_NAME || "study";
export const API_SUCCESS_MESSAGE = "保存しました。";
export const API_UNKNOWN_ERROR_MESSAGE = "不明なエラー。";
export const PREVENT_URL = "不適切なURLです。";
export const DEFAULT_TIMER = 1000;
export const INVALID_MUST_AFTER_DATE = "「{{end}}」は「{{start}}」より後にする必要があります。";
export const MAX_INTEGER = 2147483646;
export const MAX_INTEGER_INPUT_VALIDATION = 10;
export const PASSWORD_CHANGE_SUCCESS_MESSAGE = "パスワードが再設定されました。";
export const MAX_EMAIL_INPUT_VALIDATION = 60;
export const MAX_COMPANY_INPUT_VALIDATION = 60;
export const MAX_CHARACTER_INPUT_VALIDATION = 255;
export const MAX_TEXT_INPUT_VALIDATION = 1000;
export const ALLOWED_DOMAINS = ["iro-hana.com", "hopee.com.vn"];
